<template>
  <v-row style="height: 100%">
    <v-col cols="12" class="pa-0">
      <slot></slot>
      <v-footer class="pa-0 mt-n1" app :color="$attrs['footer-color'] || 'primary'">
        <v-row :class="$attrs['footer-class'] || 'text-center'">
          <v-col cols="12" class="pa-0">
            <slot name="footer"></slot>
          </v-col>
        </v-row>
      </v-footer>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      model: {},
    };
  }
};
</script>
